<template>
    <div class="panel">
        <div v-for="(item,index) in detail" :class="{item:index!=detail.length-1,item_no_border : index==detail.length-1}" :key="item.title">
            <div class="title">
                <span>{{index+1}}</span>
                <p>{{item.title}}</p>
            </div>
            <p v-for="d in item.desc" :key="d" v-html="d"></p>
        </div>
    </div>
</template>
<script>
    export default{
        name:'Help',
        data(){
            return{
                detail:[]
            }
        },
        mounted:function(){
            let name = this.$route.params.name;
            if(!name){
                name = "wallet";
            }
            let detail = this.$t("message."+name+"_info");
            if(typeof(detail) != 'object'){
                this.$router.push("/help");
            }else{
                document.title = this.$t("message."+name);
                this.detail = detail;
            }
        }
    }

</script>

<style scoped>
    .panel{
        width:100%;
        padding-left: 15px;
        box-sizing: border-box;
    }

    .item{
        border-bottom: 1px solid #f2f4f8;
    }

    .item_no_border{
        border-bottom: none;
    }

    .title{
        color:#282e42;
        font-size: 14px;
        font-weight: bold;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        margin-top: 15px;
    }

    .title span{
        color:#517bff;
        font-size: 16sp;
        margin-right: 8px;
    }

     .title>p{
        margin-top: 0;
        margin-bottom: 0;
        padding: 0;
    }

    .item>p, .item_no_border>p{
        color:#686C7A;
        font-size: 14px;
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 10px;
        margin-bottom: 15px;
        padding: 0;
    }

    .item>p a, .item_no_border>p a{
        color:#576493;
        text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/Help.vue